var _templateObject = _taggedTemplateLiteralLoose(['\n  align-self: center;\n  max-width: 78%;\n  margin: ', ';\n  font-size: 12px;\n  color: #453f6b;\n  padding: 8px;\n  border-radius: 4px;\n  background: ', ';\n'], ['\n  align-self: center;\n  max-width: 78%;\n  margin: ', ';\n  font-size: 12px;\n  color: #453f6b;\n  padding: 8px;\n  border-radius: 4px;\n  background: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  p {\n    margin: 0;\n    font-size: 12px;\n    color: #453f6b;\n    line-height: initial;\n  }\n'], ['\n  p {\n    margin: 0;\n    font-size: 12px;\n    color: #453f6b;\n    line-height: initial;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import reactHtmlParser from 'react-html-parser';
import ReactMarkdown from 'react-markdown';

var StyledBubble = styled.span(_templateObject, function (props) {
  return props.user === 'CUSTOMER' ? '0 15px 0 0' : '0 0 0 15px';
}, function (props) {
  return props.user === 'BOT' ? props.theme.lightColor : '#f4f4f4';
});

var Markdown = styled(ReactMarkdown)(_templateObject2);

var Bubble = function Bubble(_ref) {
  var message = _ref.message,
      children = _ref.children;
  return React.createElement(
    StyledBubble,
    { user: message.user },
    message.user === 'BOT' || message.user === 'OPERATOR' ? React.createElement(Markdown, { source: message.text }) : reactHtmlParser(message.text),
    children
  );
};

export default Bubble;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/message-list/message/bubble.js
// module id = 764
// module chunks = 1